<template>
  <div>
    <div class="w-full flex mb-4">
      <report-date-picker v-model="dateRange" @change="getReports"/>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 grid-cols-3 gap-4">
      <stats-card
        :loading="loading"
        class="col-span-1"
        :small-title="$t('reports.activeAlerts')"
        type="success"
        icon="nc-icon nc-spaceship">
        <template v-slot:title>
          <span class="text-base font-medium">{{ getMaxFor('alertTotals', statusTypes.ACTIVE).total }} {{$t('generic.alerts')}}</span>
        </template>
      </stats-card>

      <stats-card
        :loading="loading"
        :title="getTotalFor('alertTotals')"
        :previous-title="getTotalFor('previousAlertTotals')"
        class="col-span-1"
        :small-title="$t('Total Alerts')"
        type="warning"
        icon="nc-icon nc-spaceship">
      </stats-card>

      <stats-card
        :loading="loading"
        class="col-span-1"
        :small-title="$t('reports.activeResumes')"
        type="info"
        icon="nc-icon nc-single-copy-04">
        <template v-slot:title>
          <span class="text-base font-medium">{{ getMaxFor('resumeTotals', statusTypes.AVAILABLE).total }} {{$t('generic.resumes')}}</span>
        </template>
      </stats-card>
    </div>
    <created-resumes-report :date-from="dateFrom" :date-till="dateTill"/>
    <created-job-alerts-report :date-from="dateFrom" :date-till="dateTill"/>
  </div>
</template>
<script>
import get from 'lodash/get'
import parseISO from 'date-fns/parseISO'
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'
import subDays from 'date-fns/subDays'
import format from 'date-fns/format'
import ReportDatePicker from './ReportDatePicker'
import CreatedResumesReport from '@/views/admin/reports/CreatedResumesReport'
import CreatedJobAlertsReport from '@/views/admin/reports/CreatedJobAlertsReport'
import BarChart from 'src/components/Charts/BarChart'
import StatsCard from '@/components/Cards/StatsCard'
import ReportService from '@/services/ReportService'
import { getDefaultRange } from '@/views/admin/reports/defaultReportRange'

export default {
  components: {
    BarChart,
    StatsCard,
    ReportDatePicker,
    CreatedResumesReport,
    CreatedJobAlertsReport,
  },
  data () {
    const year = new Date().getFullYear()
    const defaultRange = getDefaultRange()
    return {
      year,
      defaultRange,
      dateRange: [...defaultRange],
      statusTypes: {
        ACTIVE: 1,
        INACTIVE: 0,
        AVAILABLE: 'available',
      },
      creditTotals: {
        results: []
      },
      creditsToExpire: {
        results: []
      },
      previousAlertTotals: {
        results: []
      },
      alertTotals: {
        results: []
      },
      resumeTotals: {
        results: []
      },
      loading: false,
    }
  },
  computed: {
    dateFrom () {
      return get(this.dateRange, '[0]', this.defaultRange[0])
    },
    dateTill () {
      return get(this.dateRange, '[1]', this.defaultRange[1])
    },
    previousDateFrom () {
      const from = parseISO(this.dateFrom)
      const till = parseISO(this.dateTill)
      const difference = differenceInCalendarDays(till, from)
      return format(subDays(from, difference), 'yyyy-MM-dd')
    },
    previousDateTill () {
      return this.dateFrom
    },
    previousAlertsReport () {
      return {
        model: 'job_alerts',
        group: 'job_alerts_status',
        select: 'id,total',
        date_range: 'custom',
        date_from: this.previousDateFrom,
        date_till: this.previousDateTill,
        sort: 'date_month',
      }
    },
    alertsReport () {
      return {
        model: 'job_alerts',
        group: 'job_alerts_status',
        select: 'id,total',
        date_range: 'custom',
        date_from: this.dateFrom,
        date_till: this.dateTill,
        sort: 'date_month',
      }
    },
    resumeReport () {
      return {
        model: 'resumes',
        group: 'resumes_status',
        select: 'id,total,resumes_status',
        date_range: 'custom',
        date_from: this.dateFrom,
        date_till: this.dateTill,
        sort: 'date_month',
      }
    },
  },
  methods: {
    getMaxFor (dataType, statusType) {
      let maxItem = {total: 0}
      const sortedResults = this[dataType].results.filter(r => r.job_alerts_status === statusType || r.resume_status === statusType)
      console.log(dataType, sortedResults, statusType, this[dataType].results)
      sortedResults.forEach(item => {
        if (item.total > maxItem.total) {
          maxItem = item
        }
      })
      return maxItem
    },
    getTotalFor (dataType) {
      let result = {total: 0}
      this[dataType].results.forEach(item => {
        result.total+= item.total
      })
      return result.total
    },
    async getReports () {
      try {
        this.loading = true
        await Promise.all([
          this.getAlertsReport(),
          this.getResumeReport(),
          this.getPreviousAlertsReports()
        ])
      } finally {
        this.loading = false
      }
    },
    async getAlertsReport () {
      const {data} = await ReportService.get(this.alertsReport)
      this.alertTotals = data
    },
    async getPreviousAlertsReports () {
      const {data} = await ReportService.get(this.previousAlertsReport)
      this.previousAlertTotals = data
    },
    async getResumeReport () {
      const {data} = await ReportService.get(this.resumeReport)
      this.resumeTotals = data
    },
  },
  mounted () {
    this.getReports()
  }
}
</script>
<style>
</style>
